import { createSelector } from 'reselect';
import { cloudIdSelector, getIssueProjectIds } from '../software/software-selectors.tsx';

export const realtimeChannelSelector = createSelector(
	[getIssueProjectIds, cloudIdSelector],
	(projectIds, cloudId) =>
		projectIds.map((projectId) => `ari:cloud:jira:${cloudId}:project/${projectId}`),
);
